<template>
  <div class="menus">
    <v-container fluid>
      <h1>Menus</h1>
      <v-layout row>
        <v-flex xs6>
          <div v-if="menus.length" >
            <div class="card-curvey delete-wrapper mt-3 pb-2" v-for="(menu,index) in menus[0].body.persistent_menu">
              <menu-data :menu="menu" :block-list="blocksList"></menu-data>
              <v-btn
                @click="handelDeleteMenu(index)"
                fab small color=""
                class="delete-button"
              ><v-icon small color="#666">delete_outline</v-icon></v-btn>
            </div>
          </div>

          <v-btn
            large round flat block
            class="primary--text"
            @click="handelAddMenu"
          >
            <v-icon>add_circle_outline</v-icon>
            Add New Menu
          </v-btn>
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<script>
  import common from "../../../../utils/common";
  import menuData from "./menuData";
  export default {
    name: "menus",
    components: {
      menuData
    },
    data() {
      return {
        menus: [],
        blocksList: []
      }
    },
    mounted() {
      this.getMenus()
      this.getBlockList()
    },
    methods: {
      getMenus () {
        this.$store.dispatch('setLoader',true)
        this.$http_bot.get('bot_objects/persistent-menu')
          .then(response=> {
            this.menus = response.data
            this.$store.dispatch('setLoader',false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      handelAddMenu() {
        if (this.menus[0]) {
          this.addMenu()
        } else {
          this.addMenus()
        }
      },
      addMenu () {
        this.menus[0].body.persistent_menu.push({
          locale: 'default',
          name: '',
          composer_input_disabled: 'false',
          call_to_actions: [
            {
              type: 'postback',
              title: 'Item name',
              payload: '',
              call_to_actions: []
            }
          ]
        })
      },
      addMenus () {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.post('/bot_objects/persistent-menu',{
          bot_id: this.$store.state.bot.botId,
          active: true,
          body: {
            persistent_menu: [
              {
                locale: 'default',
                name: '',
                composer_input_disabled: 'false',
                call_to_actions: [
                  {
                    type: 'postback',
                    title: 'Item name',
                    payload: ''
                  }
                ]
              }
            ]
          }
        })
          .then(response=> {
            this.menus.push(response.data)
            this.$store.dispatch('setSavingStatus',false)
          })
          .catch(error=>{
            this.$store.dispatch('setSavingStatus',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
      handelDeleteMenu(index) {
        if (this.menus[0].body.persistent_menu.length > 0) {
          this.deleteMenu(index)
        } else {
          this.deleteMenus(index)
        }
      },
      deleteMenu(index) {
        this.menus[0].body.persistent_menu.splice(index,1)
      },
      deleteMenus(index) {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.delete(`/bot_objects/persistent-menu/${this.menus[index].id}`)
          .then(response=>{
            this.menus.splice(index,1)
            this.$store.dispatch('setSavingStatus',false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', false)
            }
          })
      },
      getBlockList () {
        this.$http_bot.get('/blocks')
          .then(response=>{
            this.blocksList = response.data
            for (let i = 0; i<this.blocksList.length; i++) {
              this.blocksList[i].redirectName = `menu:block_id:{${this.blocksList[i].id}}`
            }
            console.log(this.blocksList)
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
      },
      updateMenu () {
        this.$store.dispatch('setSavingStatus',true)
        this.$http.put(`/bot_objects/persistent-menu/${this.menus[0].id}`, this.menus[0])
          .then(response=> {
            this.$store.dispatch('setSavingStatus',false)
          })
          .catch(error=>{
            this.$store.dispatch('setLoader',false)
            if (error.response && error.response.status === 401) {
              common.logOut()
            } else {
              this.$store.dispatch('setErrorMessage', true)
            }
          })
      },
    },
    watch: {
      menus: {
        handler(val ){
          if (this.menus[0].body.persistent_menu.length) {
            this.updateMenu()
          }
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
  .card-curvey {
    background: ghostwhite;
  }
</style>
